/*Import Requisição API*/

/* Validador de CNPJ */

export function validadorCNPJ(cnpj) {
    if (!cnpj) return false;
    cnpj = cnpj.replace(/\D/g, '');

    if (cnpj.length !== 14) return false;

    if (/^(\d)\1+$/.test(cnpj)) return false;

    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
    }

    let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado !== parseInt(digitos.charAt(0))) return false;

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
    }

    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado !== parseInt(digitos.charAt(1))) return false;

    return true;
};

/* Validador de E-mail */

export function validadorEmail(email) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
};

/* Validador de CPF */

export function validadorCPF(cpf) {
    if (!cpf) return false;
    cpf = cpf.replace(/\D/g, '');
    if (cpf.length !== 11) return false;
    let soma = 0;
    let resto;
    if (/^(\d)\1+$/.test(cpf)) return false;
    for (let i = 1; i <= 9; i++) {
        soma += parseInt(cpf.substring(i - 1, i)) * (11 - i);
    }
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.substring(9, 10))) return false;
    soma = 0;
    for (let i = 1; i <= 10; i++) {
        soma += parseInt(cpf.substring(i - 1, i)) * (12 - i);
    }
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.substring(10, 11))) return false;
    return true;
};

/* Formatador de CPF */

export function formatadorCPF(cpf) {
    if (!cpf) return '';
    return cpf
        .replace(/\D/g, '')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
};

/* Validador de CNPJ */

export function formatadorCNPJ(cnpj) {
    if (!cnpj) return '';
    return cnpj
        .replace(/\D/g, '')
        .replace(/(\d{2})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1/$2')
        .replace(/(\d{4})(\d{1,2})$/, '$1-$2');
};

/* Validador de numero de celular */

export function formatadorNumeroCelular(numero) {
    if (!numero && numero !== 0) {
        return 'N/A';
    }
    let apenasNumeros = String(numero).trim().replace(/\D/g, '');

    // Remove DDI 55 do Brasil
    if ((apenasNumeros.length === 12 || apenasNumeros.length === 13) && apenasNumeros.startsWith('55')) {
        apenasNumeros = apenasNumeros.slice(2);
    }

    // Remove zero inicial (0XX)
    if (apenasNumeros.length === 11 && apenasNumeros.startsWith('0')) {
        apenasNumeros = apenasNumeros.slice(1);
    }

    // Celular: (XX) XXXXX-XXXX
    if (apenasNumeros.length === 11) {
        return `(${apenasNumeros.slice(0, 2)}) ${apenasNumeros.slice(2, 7)}-${apenasNumeros.slice(7)}`;
    }

    // Fixo: (XX) XXXX-XXXX
    if (apenasNumeros.length === 10) {
        return `(${apenasNumeros.slice(0, 2)}) ${apenasNumeros.slice(2, 6)}-${apenasNumeros.slice(6)}`;
    }

    // Sem DDD - fixo: XXXX-XXXX
    if (apenasNumeros.length === 8) {
        return `${apenasNumeros.slice(0, 4)}-${apenasNumeros.slice(4)}`;
    }

    // Sem DDD - celular: XXXXX-XXXX
    if (apenasNumeros.length === 9) {
        return `${apenasNumeros.slice(0, 5)}-${apenasNumeros.slice(5)}`;
    }

    return apenasNumeros || String(numero);
};

/* Validador de nome completo */

export function validadorNomeCompleto(valor) {
    const nomeLimpo = valor.trim();
    const nomeValido = nomeLimpo.includes(' ') && nomeLimpo.length > 0;
    return nomeValido;
}

/* Validador númerod de ceular */

export function validadorNumeroCelular(numero) {
    if (!numero) return false;
    const celularFormatado = numero.replace(/[^\d]/g, ''); 
    return celularFormatado.length === 11;
};

/* Validador data de nascimento */

export function validadorDataNascimento(data) {
    const dataNascimento = new Date(data);
    const hoje = new Date();

    if (isNaN(dataNascimento.getTime()) || dataNascimento > hoje) {
        return false;
    }

    const diferencaAnos = hoje.getFullYear() - dataNascimento.getFullYear();
    if (diferencaAnos < 18) {
        return false;
    }

    return true;
};

/* Remove caracteres especiais */

export function removerCaracteresEspeciais(valor) {
    if (!valor) return '';
    return valor.replace(/[^\d]/g, ''); 
};

/* Formatador de data para banco de dados */

export function formatadorData(data) {
    if (typeof data !== 'string' || !data.includes('/')) {
        throw new Error('Data inválida: deve estar no formato DD/MM/YYYY');
    }

    const partes = data.split('/');

    if (partes.length !== 3) {
        throw new Error('Data inválida: deve conter dia, mês e ano');
    }

    const [dia, mes, ano] = partes;

    if (isNaN(dia) || isNaN(mes) || isNaN(ano)) {
        throw new Error('Data inválida: dia, mês e ano devem ser numéricos');
    }

    return `${ano}-${mes}-${dia}`;
};

// Função para converter DD/MM/YYYY para YYYY-MM-DD
export function converterDataParaYMD (data) {
    const partes = data.split('/');
    return `${partes[2]}-${partes[1]}-${partes[0]}`; 
};

// Formata CPF ou CNPJ
export function formatarCpfCnpj (valor) {
    if (!valor) return '';

    const apenasNumeros = valor.replace(/\D/g, '').slice(0, 14); 

    if (apenasNumeros.length <= 11) {
        return apenasNumeros
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    }

    return apenasNumeros
        .replace(/(\d{2})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1/$2')
        .replace(/(\d{4})(\d{1,2})$/, '$1-$2');
};

export function formatPreco (valor) {
    if (!valor) return '';
    return valor
    .replace(/\D/g, '') // Remove tudo que não é número
    .replace(/(\d{1,2})$/, ',$1') // Coloca a vírgula antes dos dois últimos números
    .replace(/(\d)(\d{3}),/, '$1.$2,') // Coloca o ponto a cada 3 dígitos
    .replace(/(\d)(\d{3})(\d{3}),/, '$1.$2.$3,');
};

/* Formata preço para R$XX.XX */
export function formatarPrecoReal(valor) {
    if (!valor || isNaN(valor)) return 'R$ 0.00';
    const num = parseFloat(valor);
    return `R$ ${num.toFixed(2).replace('.', ',').replace(/(\d)(\d{3}),/, '$1.$2,')}`;
}

/* Constrói descrição de variação com atributos */
export function construirDescricaoVariacao(variacao) {
    if (!variacao) return '';
    const atributos = [];
    if (variacao.cor) atributos.push(variacao.cor);
    if (variacao.tamanho) atributos.push(variacao.tamanho);
    if (variacao.tipo) atributos.push(variacao.tipo);
    if (variacao.material) atributos.push(variacao.material);
    return atributos.join(' / ') || 'Sem atributos';
}

export function getGoogleDriveUrl(url) {
    if (!url) return '';
    if (url.includes('export=view')) return url;
    const idMatch = url.match(/id=([A-Za-z0-9_-]+)/);
    if (idMatch && idMatch[1]) {
      return `https://drive.google.com/uc?export=view&id=${idMatch[1]}`;
    }
    return url;
  }

/* Máscara de celular em tempo real - (11) 91234-5678 */
export function mascaraCelular(valor) {
    if (!valor) return '';
    return valor
        .replace(/\D/g, '')
        .replace(/^(\d{2})(\d)/, '($1) $2')
        .replace(/(\d{5})(\d)/, '$1-$2')
        .slice(0, 15);
}

/* Máscara de telefone fixo em tempo real - (11) 3456-7890 */
export function mascaraTelefone(valor) {
    if (!valor) return '';
    return valor
        .replace(/\D/g, '')
        .replace(/^(\d{2})(\d)/, '($1) $2')
        .replace(/(\d{4})(\d)/, '$1-$2')
        .slice(0, 14);
}